import{__require as r}from"../start_of_week/index.js";var e,t;function n(){if(t)return e;t=1;var n=r();return e=function(r){return n(r,{weekStartsOn:1})}}export{n as __require};
//# sourceMappingURL=index.js.map
